export const COLORS = {
    background: '#12161F',
    primary: '#6a756d',
    money: '#DE893E',
    gradient: 'linear-gradient(180deg, rgba(69,182,167,1) 0%, rgba(120,205,176,1) 100%)',
    error: '#ED4337',
    warning: '#FF8800'
}

export const FONTS = {
    regular: 'Poppins-Regular',
    bold: 'Poppins-Bold'
}
export const URLS = {
    facebook_share_url: 'https://www.facebook.com/sharer/sharer.php?u=',
    twitter_share_url: 'https://twitter.com/intent/tweet?text=',
    whatsapp_share_url: 'https://api.whatsapp.com/send?text=',
    //official_site: 'https://www.bloomcycling.com' // prod
    official_site: 'https://bloom.digital-ignition.com.mx' // test
    //official_site: 'http://localhost:8000' // localhost
}

export const API = {
    //BASE_URL: 'http://localhost:5200',  //localhost
    BASE_URL: 'https://monica-api.com/bloom', //Test
    //BASE_URL: 'https://bloomhouse.mx',    //Prod
    AUTH: '/auth/'
}

export const KEYS = {
    google: '1078793044065-6vibb8ru248n5cc1n4ttjpt1d9b1qmrg.apps.googleusercontent.com', 
    facebook: "657873868210427",
    paypal: 'Aeu-TG1mCVFDJXxSCeHp3JzjvpJv5Zz_KiKPxuXGS51R4JPy0rcHEccmNnXVWXzmYsaq5DbwKq_yJifj',
    stripe: 'pk_test_zgkHGkzVr5ka25zT4F2EroMy00JxAO12Hg'
}
